import type { ReportsSearch } from "./reports-search";

export type ReportsSavedView = {
  id: string;
  label: string;
  /** Partial search patch applied on click */
  search: Partial<ReportsSearch>;
};

/** Built-in quick views - URL-driven, no server persistence. */
export const REPORTS_SAVED_VIEWS: ReportsSavedView[] = [
  {
    id: "today",
    label: "ມື້ນີ້",
    search: { tab: "sales", section: "overview", preset: "today" },
  },
  {
    id: "7d",
    label: "7 ວັນ",
    search: { tab: "sales", section: "overview", preset: "7d" },
  },
  {
    id: "month",
    label: "ເດືອນນີ້",
    search: { tab: "sales", section: "overview", preset: "month" },
  },
  {
    id: "profit-week",
    label: "ກຳໄລ 7 ວັນ",
    search: { tab: "profit", section: "overview", preset: "7d" },
  },
  {
    id: "marketing-week",
    label: "ຄ່າແອດ 7 ວັນ",
    search: { tab: "profit", section: "marketing", preset: "7d" },
  },
  {
    id: "shipping-week",
    label: "ຂົນສົ່ງ 7 ວັນ",
    search: { tab: "shipping", section: "overview", preset: "7d" },
  },
  {
    id: "stock-aging",
    label: "ຄ້າງສະຕັອກ",
    search: { tab: "stock", section: "aging" },
  },
  {
    id: "customers-cod-watch",
    label: "ລູກຄ້າ COD ສຽງ",
    search: {
      tab: "customers",
      section: "watch",
      watchKind: "cod_returns",
      minCodReturns: 1,
      preset: "7d",
    },
  },
];

export function isSavedViewActive(
  view: ReportsSavedView,
  current: Pick<ReportsSearch, "tab" | "section" | "preset">,
): boolean {
  const { search } = view;
  if (search.tab != null && search.tab !== current.tab) return false;
  if (search.section != null && search.section !== current.section)
    return false;
  if (search.preset != null && search.preset !== current.preset) return false;
  return true;
}
